import { Box, Tab, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { useResponsive } from '../hooks/useResponsive';

interface StyledTabProps {
  label: string;
  value: string;
  to: string;
  component: React.ReactNode;
}

const StyledTab = styled((props: StyledTabProps) => <Tab {...props} />)(
  ({ theme }) => ({
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(14),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  })
);

function useRouteMatch(patterns: readonly string[]) {
  const { pathname } = useLocation();

  for (const pattern of patterns) {
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
}

const Navigation = () => {
  const routeMatch = useRouteMatch([
    '/',
    '/faq',
    '/resources',
    '/guide',
    '/flowchart',
    '/contact',
  ]);
  const currentTab = routeMatch?.pattern?.path;
  const { isMobile } = useResponsive();

  return (
    <nav>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          paddingBottom: isMobile ? '32px' : '64px',
        }}
      >
        {!isMobile ? (
          <Tabs value={currentTab}>
            <StyledTab label='HOME' value='/' to='/' component={Link} />
            <StyledTab
              label='FLOWCHART'
              value='/flowchart'
              to='/flowchart'
              component={Link}
            />
            <StyledTab
              label='RESOURCES'
              value='/resources'
              to='/resources'
              component={Link}
            />
            <StyledTab label='FAQ' value='/faq' to='/faq' component={Link} />
            <StyledTab
              label='CONTACT'
              value='/contact'
              to='/contact'
              component={Link}
            />
          </Tabs>
        ) : null}
      </Box>
    </nav>
  );
};

export { Navigation };
